module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.debug_show_page_name == true) ? _c('div', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v("log-history-modal")]) : _vm._e(), _vm._v(" "), _c('modal', {
    staticClass: "change_history-modal",
    attrs: {
      "width": "95%",
      "height": "90%",
      "content_height": "90%",
      "body_height": "85%",
      "value": _vm.showModal,
      "effect": "fade",
      "large": ""
    },
    on: {
      "closed": _vm.closed
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('center', [_c('strong', [_vm._v("更新履歴")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-body change_history-modal-body ",
    staticStyle: {
      "height": "95%",
      "padding": "0px 15px",
      "overflow-x": "auto"
    }
  }, [_c('ag-grid-vue', {
    staticClass: "ag-blue",
    staticStyle: {
      "min-width": "100px",
      "width": "100%",
      "height": "200px"
    },
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  }), _vm._v(" "), (_vm.showDetails) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "30px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("古いデータ")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("新しいデータ")])]), _vm._v(" "), _vm._l((_vm.dataChangesA), function(d) {
    return _c('tr', {
      key: d.id
    }, [_c('th', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.label))]), _vm._v(" "), _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))]), _vm._v(" "), (d.n.length > 0) ? _c('td', {
      staticClass: "hist_td",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(d.n))]) : _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))])])
  })], 2), _vm._v(" "), (_vm.bulkTorokuNumber != null) ? _c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "20px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td",
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("一括編集No")]), _vm._v(" "), _c('td', {
    staticClass: "hist_td",
    attrs: {
      "colspan": "2"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-plain ",
    staticStyle: {
      "margin": "-10px -10px"
    },
    attrs: {
      "to": '/approval_history/toroku_filter/' + _vm.bulkTorokuNumber,
      "type": "button"
    }
  }, [_vm._v(_vm._s(_vm.bulkTorokuNumber))])], 1)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [(Array.isArray(_vm.dataChangesB)) ? _c('table', {
    staticClass: "hist_td",
    staticStyle: {
      "margin": "auto",
      "margin-top": "30px",
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hist_td"
  }, [_vm._v("項目")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("古いデータ")]), _vm._v(" "), _c('th', {
    staticClass: "hist_td"
  }, [_vm._v("新しいデータ")])]), _vm._v(" "), _vm._l((_vm.dataChangesB), function(d) {
    return _c('tr', {
      key: d.id
    }, [_c('th', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.label))]), _vm._v(" "), _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))]), _vm._v(" "), (d.n.length > 0) ? _c('td', {
      staticClass: "hist_td",
      staticStyle: {
        "color": "red"
      }
    }, [_vm._v(_vm._s(d.n))]) : _c('td', {
      staticClass: "hist_td"
    }, [_vm._v(_vm._s(d.o))])])
  })], 2) : _vm._e()])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.changeTime) + "\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closed('no')
      }
    }
  }, [_vm._v("戻る")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60c14860","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/change-history-modal.vue
// module id = 1007
// module chunks = 0